import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, TemplateRef } from '@angular/core';
import {
  FieldArrayType,
  FieldArrayTypeConfig,
  FormlyFieldProps,
  FormlyModule,
} from '@ngx-formly/core';
import { ButtonModule } from 'primeng/button';

interface RepeatProps extends FormlyFieldProps {
  addButton: string;
  removeText: string;
  emptyTemplate?: TemplateRef<unknown>;
  emptyText?: string;
  showAddButtonWhenEmpty?: boolean;
  disableAdd?: boolean;
  disableRemove?: boolean;
}

export interface FormlyRepeatFieldConfig
  extends FieldArrayTypeConfig<RepeatProps> {}

@Component({
    selector: 'kon-repeat-type',
    imports: [CommonModule, FormlyModule, ButtonModule],
    template: `
    <div class="mb-3">
      @if (props.label) {
        <legend>{{ props.label }}</legend>
      }
      @if (props.description) {
        <p>{{ props.description }}</p>
      }
    
      @if (field.fieldGroup?.length === 0) {
        @if (props.emptyTemplate) {
          <ng-container
            *ngTemplateOutlet="
              props.emptyTemplate;
              context: { field: field, add: add }
            "
          ></ng-container>
        } @else {
          <p class="text-gray-500 font-semibold mt-4">{{ props.emptyText }}</p>
        }
      } @else {
        @for (field of field.fieldGroup; track field.name) {
          <div
            class="flex items-stretch py-1.5 mb-1.5 border-t border-gray-200 first:border-t-0 last:mb-0 first:pt-0 last:pb-0"
            >
            <formly-field class="flex-1" [field]="field"></formly-field>
            @if (!props.disableRemove) {
              <div class="flex flex-col justify-start">
                <button
                  pButton
                  type="button"
                  [label]="props.removeText"
                  (click)="remove($index)"
                  icon="pi pi-times"
                  class="p-button-danger p-button-text ml-1"
                ></button>
              </div>
            }
          </div>
        }
      }
      @if (
        (props.showAddButtonWhenEmpty || field.fieldGroup?.length !== 0) &&
        !props.disableAdd
        ) {
        <div class="flex items-center">
          <button
            pButton
            type="button"
            [label]="props.addButton"
            (click)="add()"
            icon="pi pi-plus"
            class="p-button-secondary w-full"
          ></button>
        </div>
      }
    </div>
    `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlyRepeatTypeComponent extends FieldArrayType<
  FieldArrayTypeConfig<RepeatProps>
> {
  override defaultOptions?:
    | Partial<FieldArrayTypeConfig<RepeatProps>>
    | undefined = {
    props: {
      addButton: 'Pridať',
      removeText: '',
      showAddButtonWhenEmpty: true,
      emptyText: 'Žiadne položky',
    },
  };
}
